














import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../../../../lib/abpbase"
import DialysisRecords from './dialysisRecords'
import Complication from './complication'
import StopRecords from './stopRecords'
import CancelRecords from './cancelRecords'
@Component({
	components:{DialysisRecords, Complication, StopRecords, CancelRecords}
})
export default class Patient extends AbpBase {
	@Prop() patient :any
	data = this.patient
	position = "透析记录"
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/index.vue